module.exports = __webpack_public_path__ + "img/dating.aee9c32.png";